import React, { Component } from 'react';

export class DropDownInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options: props.options,
            filteredOptions: props.options,
            selectedValue: '',
            selectedValueText: '',
            dropped: false,
            defaultValue: props.defaultValue,
            isFloatingDropdown: props.isFloatingEnabled,
            hasSearch: props.hasSearch,
            searchQuery: null
        };
        this.getDropDownValue = this.getDropDownValue.bind(this);
    }

    // click listener for event outside of dropped list (to close list)
    componentWillMount() {
        document.addEventListener('mousedown', this.handleDropClick, false);
    }

    // if defaultValue passed, set that value and its text to state
    componentDidMount() {
        if (typeof this.state.defaultValue !== 'undefined') {
            const index = this.state.options.findIndex((opt) => opt.data === this.state.defaultValue);
            if (index > -1) {
                this.setState({
                    selectedValue: this.state.defaultValue,
                    selectedValueText: this.state.options.filter((o) => o.data === this.state.defaultValue)[0].display
                });
            }
        }
    }

    // event listener cleanup
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleDropClick, false);
    }

    // handler for click listener to close dropper if click outside list.
    handleDropClick = (e) => {
        if (this.node.contains(e.target)) {
            return;
        }
        this.setState({ dropped: false });
    };

    componentDidUpdate(prevProps) {
        if (this.props.value && this.props.value != prevProps.value) {
            //console.log(this.props);
            this.setState({
                selectedValue: this.props.value,
                selectedValueText: this.state.options.filter((s) => s.data === this.props.value)[0]?.display
            });
        } else if (this.props.value === '' && this.props.value !== prevProps.value) {
            this.setState({
                selectedValue: '',
                selectedValueText: ''
            });
        }
        if (JSON.stringify(this.props.options) !== JSON.stringify(prevProps.options)) {
            this.setState({
                options: this.props.options
            });
        }
        // using ref to set focus on list open
        if (this.state.hasSearch) this.optionSearch.focus();
    }

    getDropDownValue = (value, e) => {
        this.setState(
            {
                selectedValue: value,
                selectedValueText: this.state.options.filter((s) => s.data === value)[0].display,
                dropped: false
            },
            () => this.props.onChangedValue(value)
        );
    };

    handleSearchOptions = (e) => {
        const searchQuery = e.target.value.toLowerCase();
        const filteredOptions = [...this.state.options.filter((o) => o.display.toLowerCase().includes(searchQuery))];
        this.setState({
            searchQuery,
            filteredOptions
        });
    };

    render() {
        const getFilteredOptions = () => {
            if (this.state.searchQuery) return this.state.filteredOptions;
            return this.state.options;
        };

        return (
            <div className={this.state.isFloatingDropdown ? 'full-width has-float-label' : 'full-width'}>
                <div
                    className='dropdown'
                    id='drpdown'
                    ref={(node) => (this.node = node)}
                >
                    <button
                        className={
                            this.props.fullWidth
                                ? 'optionsBtn dropbtn dropbtn-placeholder form-control'
                                : 'dropbtn dropbtn-placeholder form-control'
                        }
                        onClick={(e) => {
                            e.preventDefault();
                            this.setState({ dropped: !this.state.dropped });
                        }}
                        disabled={this.props.disabled}
                    >
                        {this.state.selectedValue === '' ? this.props.placeholder : this.state.selectedValueText}
                    </button>

                    <div
                        className='dropdown-content'
                        style={{ display: this.state.dropped ? 'block' : 'none' }}
                    >
                        {this.state.hasSearch && (
                            <input
                                className='dropdown-search'
                                placeholder='Search...'
                                type='text'
                                autofocus='true'
                                ref={(field) => (this.optionSearch = field)}
                                onChange={this.handleSearchOptions}
                            />
                        )}
                        {getFilteredOptions().map((opt, index) => (
                            <a
                                key={index}
                                onClick={this.getDropDownValue.bind(this, opt.data)}
                            >
                                {opt.display}
                            </a>
                        ))}
                    </div>
                </div>
                {this.state.isFloatingDropdown ? (
                    <label htmlFor='drpdown'>{this.state.selectedValue === '' ? '' : this.props.placeholder}</label>
                ) : null}
            </div>
        );
    }
}
